import * as XLSX from 'xlsx';

interface ISnapshotMicroArea {
  daily_metrics: {
    date: string;
    average_instant_capacity_rate: number;
    total_consumption_kg: number;
    average_height: number;
    average_rating: number;
    strip_movements_count: number;
    micro_area: {
      id: number;
      initials: string;
      average_capacity_rate: number;
      consumption_kg: number;
      height: number;
      rating: number;
      strip_movements: number;
    }[];
  }[];
}

export const exportPastureManagementMicroAreaDataToExcel = (
  snapshotMicroAreaMetrics: ISnapshotMicroArea,
  startDate?: Date,
  endDate?: Date
) => {
  if (!snapshotMicroAreaMetrics || !snapshotMicroAreaMetrics.daily_metrics || snapshotMicroAreaMetrics.daily_metrics.length === 0) {
    throw new Error('Dados insuficientes para exportação');
  }

  const workbook = XLSX.utils.book_new();

  const expandedData: any[] = [];

  snapshotMicroAreaMetrics.daily_metrics.forEach((dailyMetric) => {
    if (dailyMetric.micro_area && dailyMetric.micro_area.length > 0) {
      dailyMetric.micro_area.forEach((microArea) => {
        expandedData.push({
          'Data': dailyMetric.date,
          'Microárea': microArea.initials,
          'Taxa de lotação (UA/ha)': parseFloat((microArea.average_capacity_rate || 0).toFixed(2)),
          'Consumo suplemento (Kg)': parseFloat((microArea.consumption_kg || 0).toFixed(2)),
          'Altura pasto': microArea.height !== null && microArea.height !== undefined ? parseFloat((microArea.height || 0).toFixed(2)) : '',
          'Nota pasto': microArea.rating !== null && microArea.rating !== undefined ? parseFloat((microArea.rating || 0).toFixed(2)) : '',
          'Movimentos de faixa': microArea.strip_movements !== null && microArea.strip_movements !== undefined ? microArea.strip_movements : ''
        });
      });
    }
  });

  const metricsWorksheet = XLSX.utils.json_to_sheet(expandedData);
  metricsWorksheet['!cols'] = [
    { wch: 15 }, // Data
    { wch: 15 }, // Microárea
    { wch: 25 }, // Taxa de lotação
    { wch: 25 }, // Consumo suplemento
    { wch: 15 }, // Altura pasto
    { wch: 15 }, // Nota pasto
    { wch: 20 }  // Movimentos de faixa
  ];
  XLSX.utils.book_append_sheet(workbook, metricsWorksheet, 'Métricas por Microárea');

  const excelBuffer = XLSX.write(workbook, { 
    bookType: 'xlsx', 
    type: 'array' 
  });

  const blob = new Blob([excelBuffer], { 
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
  });
  
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  
  let filename = 'manejo-pasto-microarea';
  if (startDate && endDate) {
    const startStr = startDate.toISOString().split('T')[0];
    const endStr = endDate.toISOString().split('T')[0];
    filename = `manejo-pasto-microarea-${startStr}-${endStr}.xlsx`;
  } else {
    filename = `manejo-pasto-microarea-${new Date().toISOString().split('T')[0]}.xlsx`;
  }
  
  link.download = filename;
  
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};

